export default __webpack_public_path__ + "static/media/feature2_2.402b4b81.png";